import "angular";
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-resource";
import "angular-cookies";
import AccuCodeService from "../layout/service/AccuCodeService";

import TranslateConfig from "./TranslateConfig";
import TranslateService from "./TranslateService";

const TranslateServiceModule = angular
    .module("TranslateServiceModule", [
        "pascalprecht.translate",
        "ngResource",
        "LayoutModule",
        "ngCookies"
    ])
    .service("AccuCodeService", AccuCodeService)
    .service("translateService", TranslateService)
    .config(TranslateConfig);

export default TranslateServiceModule;
